module.exports = __webpack_public_path__ + "img/Kotak-Securities-Logo.03aa35de.jpg";